module.exports = __webpack_public_path__ + "static/media/partner8.4d24882a.png";